/**
 * LegalPageLayout - Layout commun pour les pages légales
 * Fournit une structure cohérente pour mentions légales, CGU, confidentialité, cookies
 */
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface LegalPageLayoutProps {
  title: string
  lastUpdate: string
  children: ReactNode
}

export default function LegalPageLayout({
  title,
  lastUpdate,
  children,
}: LegalPageLayoutProps) {
  return (
    <div className="max-w-3xl mx-auto py-8 px-4">
      {/* Retour accueil */}
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          />
        </svg>
        Retour à l'accueil
      </Link>

      {/* En-tête */}
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
        <p className="text-sm text-gray-500">
          Dernière mise à jour : {lastUpdate}
        </p>
      </header>

      {/* Contenu */}
      <article className="prose prose-gray max-w-none">
        {children}
      </article>

      {/* Navigation entre pages légales */}
      <nav className="mt-12 pt-8 border-t border-gray-200">
        <p className="text-sm text-gray-500 mb-4">Autres informations légales</p>
        <div className="flex flex-wrap gap-4 text-sm">
          <Link
            to="/mentions-legales"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Mentions légales
          </Link>
          <Link
            to="/cgu"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            CGU
          </Link>
          <Link
            to="/confidentialite"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Confidentialité
          </Link>
          <Link
            to="/cookies"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Cookies
          </Link>
        </div>
      </nav>
    </div>
  )
}
